import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { InvoiceService } from "src/app/_services/invoice.service";
import { PosService } from "src/app/_services/posService";
import { S3Service } from "src/app/_services/s3.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-invoice-detail",
  templateUrl: "./invoice-detail.component.html",
  styleUrls: ["./invoice-detail.component.scss"],
})
export class InvoiceDetailComponent implements OnInit {
  po: any;
  responseData: any;
  isError: any;
  isEmpty = false;
  loading = true;
  displayName: any;
  invoice: any;
  utrExist = false;
  paymentDateExist = false;
  paymentAdviceExist = false;
  paymentDueDateExist = false;
  isCondensed = false;
  debitNoteExist = false;
  currentLayout = {
    isCondensed: true,
  };
  showing = false;
  showStatusInfo = false;
  paidStatus: any = {};
  postedStatus: any = {};

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private datePipe: DatePipe,
    private invoiceService: InvoiceService,
    private posService: PosService,
    private s3Service: S3Service
  ) {}

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  statusInfo() {
    this.showing = true;
    this.showStatusInfo = true;
  }

  closeStatusInfo() {
    this.showing = false;
    this.showStatusInfo = false;
  }

  ngOnInit(): void {
    this.displayName = localStorage.getItem("displayName");
    const code = this.route.snapshot.params["barcode"];
    const userData = {
      barcode: code,
    };

    this.invoiceService.getInvoiceDetails(userData).subscribe(
      async (res) => {
        console.log(res);

        this.loading = false;
        this.responseData = res;

        this.invoice = this.responseData.data[0];
        console.log(this.invoice, "invoice data");

        const config: any = this.invoiceService.getAllConfig();
        console.log(config, "config");

        if (this.invoice.purchaseOrg) {
          const purchaseOrg = config.purchaseOrganizations.find((item: any) => item.purchaseOrganization === this.invoice.purchaseOrg);
          console.log(purchaseOrg, "purchaseOrg");
          if (purchaseOrg) {
            this.invoice.purchaseOrgName = `${purchaseOrg.purchaseOrganization} - ${purchaseOrg.description}`;
          }
        }

        if (this.invoice.barcode) {
          console.log(this.s3Service, "s3Service");
          // console.log(await this.s3Service.getFile(`uploaded_pdfs/${this.invoice.barcode}.pdf`));
          (await
            // console.log(await this.s3Service.getFile(`uploaded_pdfs/${this.invoice.barcode}.pdf`));
            this.s3Service.getFile(`${environment.uploadedPdfsS3Prefix}/${this.invoice.barcode}.pdf`)).subscribe((response: any) => {
            console.log(response, "response");
            this.invoice.file_link = `${environment.dataUrl}appprxy?path=${response.data.url}`;
            console.log(this.invoice.file_link, "file_link");

          });
          // console.log(url, "url");
          
          // this.invoice.file_link = `${environment.dataUrl}appprxy?path=${url}`;
          console.log(this.invoice.file_link, "file_link");
        }

        if (this.invoice.paymentAdviceLink) {
          (await
            // console.log(await this.s3Service.getFile(`uploaded_pdfs/${this.invoice.barcode}.pdf`));
            this.s3Service.getFile(`${environment.downloadedPdfsS3Prefix}/${this.invoice.paymentAdviceLink}`)).subscribe((response: any) => {
            console.log(response, "response");
            this.invoice.paymentAdviceLink = `${environment.dataUrl}appprxy?path=${response.data.url}`;
            console.log(this.invoice.paymentAdviceLink, "paymentAdviceLink");

          });
          console.log(this.invoice.paymentAdviceLink, "paymentAdviceLink");
        }

        if (this.invoice.docDate) {
          this.invoice.docDate = this.formatDocDate(this.invoice.docDate);
        }

        if (this.invoice.dueDate) {
          this.invoice.dueDate = this.formatDocDate(this.invoice.dueDate);
        }

        this.paidStatus = this.invoice.gpStatus.statusHistory.find((status) => status.status === "PAID");
        this.postedStatus = this.invoice.gpStatus.statusHistory.find((status) => status.status === "POSTED");

        if (this.checkObjectKeyExist(this.invoice, "rejections", "rej1") === undefined) {
          Object.assign(this.invoice, { rejection1: false });
        } else {
          Object.assign(this.invoice, { rejection1: true });
        }

        if (this.checkObjectKeyExist(this.invoice, "rejections", "rej2") === undefined) {
          Object.assign(this.invoice, { rejection2: false });
        } else {
          Object.assign(this.invoice, { rejection2: true });
        }

        if (this.checkObjectKeyExist(this.invoice, "gst_reconciled") === undefined) {
          Object.assign(this.invoice, { gst_exist: false });
        } else {
          Object.assign(this.invoice, { gst_exist: true });
        }

        if (typeof this.invoice.utrNo !== "undefined" && typeof this.invoice.utrNo && this.invoice.utrNo !== "") {
          this.utrExist = true;
        }

        if (typeof this.invoice.payDate !== "undefined" && this.invoice.payDate !== null && this.invoice.payDate !== "") {
          this.paymentDateExist = true;
        }

        if (typeof this.invoice.payment_due_date !== "undefined" && this.invoice.payment_due_date !== null && this.invoice.payment_due_date !== "") {
          this.paymentDueDateExist = true;
        }

        if (typeof this.invoice.debit_note_attachment !== "undefined" && this.invoice.debit_note_attachment !== null && this.invoice.debit_note_attachment !== "") {
          this.debitNoteExist = true;
        }

        if (typeof this.invoice.payment_advice_attachment !== "undefined" && this.invoice.payment_advice_attachment !== null && this.invoice.payment_advice_attachment !== "") {
          this.paymentAdviceExist = true;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  checkObjectKeyExist(obj, ...args) {
    return args.reduce((obj, level) => obj && obj[level], obj);
  }

  openPdfInNewTab(pdfUrl: string) {
    if (pdfUrl) {
      // Create a new window and navigate to the PDF URL
      const newWindow = window.open("", "_blank");
      if (newWindow) {
        newWindow.location.href = pdfUrl;
      }
    }
  }

  // hasProp(obj: any, name: any) {
  //     return obj.hasOwnProperty(name);
  // }

  formatDocDate(docDate: string): string {
    if (!docDate || docDate.length !== 8) {
      return docDate;
    }

    // Convert ddmmyyyy to yyyy-mm-dd format for Angular date pipe
    const day = docDate.substring(0, 2);
    const month = docDate.substring(2, 4);
    const year = docDate.substring(4, 8);

    return `${year}-${month}-${day}`;
  }
}
